import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@guards/auth.guard';
import { LoggedInGuard } from '@core/guards/logged-in.guard';
import { ROUTE_PATH } from '@utils/route-path';

const routes: Routes = [
  {
    path: ROUTE_PATH.root,
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/features/features.module').then(m => m.FeaturesModule),
  },
  {
    path: ROUTE_PATH.authRoot,
    canActivate: [LoggedInGuard],
    loadChildren: () =>
      import('./modules/auth/auth.module').then(m => m.AuthModule),
  },
  {
    path: 'exception',
    loadChildren: () => import('./modules/exception/exception.module').then(m => m.ExceptionModule),
  },
  {
    path: ROUTE_PATH.privacyPolicy.path,
    loadComponent: () =>
      import('./modules/policy/policy.component').then(m => m.PolicyComponent),
  },
  {
    path: '',
    redirectTo: ROUTE_PATH.root,
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: ROUTE_PATH.error[404],
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
